import { KnownTrackingStatuses, SmartSendItemApiModel, TrackingStatus } from '~/lib/api/smartsend/types';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { SmartSendProvider } from '~/lib/consts/providers';

const DeprecatedActions = ['CANCELLATION_PAGE'];

function getItemProvider(item: SmartSendItemApiModel) {
  return item.BookingDetails?.Service?.Provider || item.Service?.Provider;
}

export function GetInTransitOrderActions(hasRefund: boolean, hasClaim: boolean, item: SmartSendItemApiModel) {
  const options: string[] = ['BUY-AGAIN_ONCLICK'];
  switch (getItemProvider(item)) {
    case SmartSendProvider:
      if (!hasClaim) {
        // options.push('ORDER-OPENCLAIM_PAGE');
        options.push('RAISE-ENQUIRY_ONCLICK');
      }

      if (!hasRefund) {
        options.push('ORDER-INVOICE_DOWNLOAD');
      }

      options.push('ARRANGE-RETURN_ONCLICK');

      break;
    default:
  }

  return options.filter((x) => !DeprecatedActions.includes(x)); // Deprecated;
}

const newTrackingStatuses: TrackingStatus[] = ['New', 'Created'];

export function GetOrderActions(hasRefund: boolean, hasClaim: boolean, item: SmartSendItemApiModel) {
  const options = ['HELPCENTRE_PAGE', 'BUY-AGAIN_ONCLICK'];

  switch (getItemProvider(item)) {
    case SmartSendProvider:
      if (SettingsCache.settings.Features.includes('ReturnCollection')) {
        options.push('ARRANGE-RETURN_ONCLICK');
      }

      if (!hasRefund) {
        options.push('ORDER-INVOICE_DOWNLOAD');

        const inTransit =
          !!item.TrackingSummary?.Collected ||
          !!item.TrackingSummary?.DroppedOff ||
          (KnownTrackingStatuses.includes(item.Statuses?.TrackingStatus) &&
            !newTrackingStatuses.includes(item.Statuses.TrackingStatus));

        if (inTransit) {
          if (!hasClaim) {
            options.push('RAISE-ENQUIRY_ONCLICK');
          }
        } else {
          options.push('ORDER-DROPSHOP_PAGE');
          options.push('CANCELLATION_PAGE');
          options.push('CANCEL_ONCLICK');
          options.push('ORDER-EDITDETAILS_PAGE');
          options.push('ORDER-REBOOK_PAGE');
        }
      }

      break;
    default:
  }

  return options.filter((x) => !DeprecatedActions.includes(x)); // Deprecated
}
